import { isBefore } from 'date-fns/isBefore';
import { subMilliseconds } from 'date-fns/subMilliseconds';

import { OrderPaymentStatus } from '@sg/graphql-schema';

export const isOrderPaymentStatePending = (
  paymentStateStatus: OrderPaymentStatus | undefined,
  paymentStateExpiration: number | undefined,
  paymentStateExpirationTolerance: number,
) => {
  const paymentStateExpirationDate = new Date(Number(paymentStateExpiration));
  const expirationDate = subMilliseconds(new Date(), paymentStateExpirationTolerance);

  const isCreated = paymentStateStatus === OrderPaymentStatus.Created;
  const isApproved = paymentStateStatus === OrderPaymentStatus.Approved;
  const isPending = isCreated || isApproved;
  const isExpired = isBefore(paymentStateExpirationDate, expirationDate);

  return isPending && !isExpired;
};

export const getOrderPaymentStateConfig = (config?: Record<string, number>) => {
  return {
    paymentStatePollingInterval: getNumberOrNull(config?.pollingInterval) || 3000,
    paymentStateExpirationTolerance: getNumberOrNull(config?.expirationTolerance) || 1000 * 60 * 2,
    paymentStateDelayedTolerance: getNumberOrNull(config?.delayedTolerance) || 12_000,
  };
};

const getNumberOrNull = (value?: string | number) => {
  return Number.isNaN(Number(value)) ? null : Number(value);
};
